import gql from 'graphql-tag';

import { AlbumFolderForPrintAssetDetails } from '../fragments/album-folder';

export const AlbumMembershipGroupForPurchasingOptionsCheck = gql`
  query AlbumMembershipGroupForPurchasingOptionsCheck($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      identities {
        identity {
          id
        }
        has_purchased_subscription
      }
      album {
        id
        album_subtype
        search_subscription_credits_joins_enabled
        web_gallery_print_purchases_enabled
        pre_paid: is_demo
        price_whole_album {
          value
        }
        root_album_folder {
          id
          price {
            value
          }
          album_folder_print_packages {
            total
          }
          digital_bundles {
            total
          }
        }
      }
      album_folder {
        id
        album_subtype
        search_subscription_credits_joins_enabled
        web_gallery_print_purchases_enabled
        pre_paid: is_demo
        price {
          value
        }
        digital_bundles {
          total
        }
      }
      album_custom_prints(
        slice: { limit: 1 }
        custom_print_types: [CUSTOM_PRINT]
        custom_print_subtype: null
      ) {
        total
      }
      account_card_album_custom_prints: album_custom_prints(
        slice: { limit: 1 }
        custom_print_types: [PRINT_PRODUCT]
        custom_print_subtype: null
      ) {
        total
      }
      specialty_custom_prints: album_custom_prints(
        slice: { limit: 1 }
        custom_print_types: [CUSTOM_PRINT]
        custom_print_subtype: SPECIALTY_PRINT
      ) {
        total
      }
      print_packages {
        ... on IHierarchyPrintPackage {
          id
        }
      }
      photo_pricing {
        id
      }
    }
  }
`;

export const AlbumMembershipGroupForPrintBackgrounds = gql`
  query AlbumMembershipGroupForPrintBackgrounds($id: RecordID!) {
    albumMembershipGroup(
      id: $id
      root_groups_only: true
      include_matched_photos_only: true
    ) {
      id
      album_folder {
        id
        ...AlbumFolderForPrintAssetDetails
      }
      album {
        id
        root_album_folder {
          id
          ...AlbumFolderForPrintAssetDetails
        }
      }
      print_packages {
        ... on IHierarchyPrintPackage {
          id
          print_package {
            id
            print_assets(slice: { limit: 999 }) {
              total
              records {
                id
                print_asset {
                  id
                  name
                  type
                  jersey_colors(slice: { limit: 999 }) {
                    records {
                      id
                      jersey_color
                    }
                  }
                  asset_image {
                    id
                    url
                    width
                    height
                  }
                }
              }
            }
          }
        }
      }
      photo_pricing {
        id
        print_assets(slice: { limit: 999 }) {
          total
          records {
            id
            print_asset {
              id
              name
              type
              jersey_colors(slice: { limit: 999 }) {
                records {
                  id
                  jersey_color
                }
              }
              asset_image {
                id
                url
                width
                height
              }
            }
          }
        }
      }
    }
  }
  ${AlbumFolderForPrintAssetDetails}
`;
